import moment from "moment/moment";
import { convertedEquals, versionNow } from "./HistoryUtils";

export function addPrimitiveDiffToResults(key, anamnesisDtoValue, primitiveHistory, result, supplementalQuestionData) {
    const latestHistoryEntry = primitiveHistory[key];
    const newValueWithoutHistory = !latestHistoryEntry || latestHistoryEntry?.length === 0;
    if (newValueWithoutHistory) {
        result[key] = newPrimitiveHistoryEntry(key, anamnesisDtoValue, supplementalQuestionData);
    } else if (latestHistoryEntry && latestHistoryEntry.length > 0) {
        if (!convertedEquals(latestHistoryEntry[0].anamnesisQuestion.answer, anamnesisDtoValue)) {
            if (latestHistoryEntry[0].anamnesisQuestion.version === versionNow()) {
                result[key] = updatePrimitiveHistoryEntry(
                    latestHistoryEntry,
                    anamnesisDtoValue,
                    supplementalQuestionData,
                );
            } else {
                result[key] = newPrimitiveHistoryEntry(key, anamnesisDtoValue, supplementalQuestionData);
            }
        }
    }
}

function updatePrimitiveHistoryEntry(latestHistoryEntry, newValue, { role, userId }) {
    return [
        {
            ...latestHistoryEntry[0],
            anamnesisQuestion: {
                ...latestHistoryEntry[0].anamnesisQuestion,
                answer: newValue,
                role,
                userId,
                modificationDate: moment().toISOString(),
            },
        },
    ];
}

function newPrimitiveHistoryEntry(key, value, { patientId, role, userId }) {
    return [
        {
            anamnesisQuestion: {
                patientId,
                question: key,
                answer: value,
                version: versionNow(),
                modificationDate: moment().toISOString(),
            },
        },
    ];
}
